export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-960-50298d698b369a4c37ebdef5882dd23a.webp";